/*
 * Makes the buy box's brand-wide rating row jump to the page's review section.
 *
 * The row renders with no href (see assets/product-rating-row.css). This finds the review
 * section, points every copy of the link at it, and smooth-scrolls on click. Where there
 * is no review section — the bundle PDPs have none — no href is ever added and the link
 * stays inert rather than offering a dead click.
 *
 * Same shape as the buy-box jump in sections/annoucement-bar-v2.liquid: a selector list
 * most-specific-first, a getClientRects() visibility check so a display:none candidate is
 * skipped, and delegated clicks so the theme editor re-rendering a section cannot unbind
 * anything. Delegation also covers the fact that a v3 PDP renders this row twice (once in
 * the buy box, once hoisted above the gallery for mobile).
 */
(function () {
  if (window.Roostys && window.Roostys.ratingRowJump) return;
  window.Roostys = window.Roostys || {};
  window.Roostys.ratingRowJump = true;

  /*
   * Most specific first. [data-rating-row-target] is the explicit opt-in for a template
   * whose review section none of the generic selectors catch. #looxReviews covers both
   * Loox's own app block and sections/loox-reviews-lander.liquid. The id*= pairs catch
   * the theme's own review sections by section id — `reviews` (pdp-reviews) and
   * `rs_reviews_*` (RS-reviews) both contain "review".
   */
  var REVIEW_SELECTORS = [
    '[data-rating-row-target]',
    '#looxReviews',
    '.loox-reviews-default',
    '[id^="shopify-section"][id*="review"]',
    '[id^="shopify-section"][id*="Review"]',
    '[id^="shopify-section"][id*="loox"]',
  ];

  var JUMP_ID = 'roostys-reviews';
  /* Keeps the section's heading clear of the viewport edge. This always scrolls DOWN —
     the buy box is above every review section — so the on-scroll-up header stays hidden
     and needs no offset of its own. */
  var SCROLL_GAP = 16;

  function links() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-rating-row-jump]'));
  }

  function reviewSection(reference) {
    for (var i = 0; i < REVIEW_SELECTORS.length; i += 1) {
      var nodes = document.querySelectorAll(REVIEW_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        var node = nodes[j];
        // Skip a hidden candidate: it measures top 0 and would scroll nowhere.
        if (!node.getClientRects().length) continue;
        // Never point the row at itself or at an ancestor that contains it.
        if (reference && node.contains(reference)) continue;
        // Only jump forward, so a review section above the buy box cannot scroll the
        // customer back up the page.
        if (
          reference &&
          !(reference.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING)
        ) {
          continue;
        }
        return node;
      }
    }
    return null;
  }

  function emit(action) {
    document.dispatchEvent(
      new CustomEvent('roostys:rating-row', { detail: { action: action }, bubbles: true })
    );
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'roostys_rating_row', rating_row_action: action });
    }
  }

  /*
   * Sections below the buy box may not exist yet when this runs, and Loox injects its
   * container after its own script loads, so this is re-run on load and on section render
   * rather than once on DOMContentLoaded.
   */
  function upgradeLinks() {
    var all = links();
    if (!all.length) return;

    var target = reviewSection(all[0]);
    if (!target) return;
    if (!target.id) target.id = JUMP_ID;

    all.forEach(function (link) {
      link.setAttribute('href', '#' + target.id);
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-rating-row-jump]');
    if (!link || !link.hasAttribute('href')) return;

    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;

    event.preventDefault();
    emit('jump_to_reviews');

    var top = target.getBoundingClientRect().top + window.scrollY - SCROLL_GAP;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });

    // Move focus with the view for keyboard and screen-reader users.
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upgradeLinks, { once: true });
  } else {
    upgradeLinks();
  }
  window.addEventListener('load', upgradeLinks);
  document.addEventListener('shopify:section:load', upgradeLinks);
})();
